export interface SEOMetadata {
  title?: string;
  description?: string;
  image?: string;
  slug?: string;
  keywords?: string;
  author?: string;
  twitter_author?: string;
  route?: string;
  date?: Date;
  featured_image?: string;
}